// Importa o React e hooks necessários
import React, { useRef, useState } from "react";
// Importa a biblioteca para capturar o componente como imagem
import html2canvas from "html2canvas";
// Importa o CSS específico deste componente
import "./AssinaturaCard.css";
// Importa o CSS do Bootstrap para estilização
import 'bootstrap/dist/css/bootstrap.min.css';
// Importa o componente Link para navegação entre rotas
import { Link } from 'react-router-dom';
// Importa as imagens utilizadas no componente
import Images from "../../img/imagens";

// Componente principal para geração de assinatura de e-mail
const AssinaturaCard = () => {
    // Referência ao card de assinatura para captura de imagem
    const cardRef = useRef();

    // Estado para controlar se a assinatura é departamental (sem nome/cargo individual)
    const [cargoOpcional, setCargoOpcional] = useState(false);
    // Estado para controlar se o campo nome é opcional (sincronizado com cargoOpcional)
    const [nomeOpcional, setNomeOpcional] = useState(false);

    // Estado do formulário com todos os campos necessários
    const [form, setForm] = useState({
        nome: "",
        cargo: "",
        coordenadoria: "",
        sigla: "",
        unidade: "",
        email: "",
        telefone: "",
        telefoneAlternativo: "",
        endereco: "",
        cepCidadeEstado: ""
    });

    // Mapeamento dos setores por coordenadoria para seleção dinâmica
    const setoresPorCoordenadoria = {
        CGM: [
            { sigla: "CGM", unidade: "CONTROLADORIA GERAL DO MUNICIPIO" },
            { sigla: "GAB", unidade: "GABINETE DA CONTROLADORIA" },
            { sigla: "APRI", unidade: "ASSESSORIA PRODUCAO DE INFORMACOES E INTELIGENCIA" },
            { sigla: "AT", unidade: "ASSESSORIA TECNICA" },
            { sigla: "AJ", unidade: "ASSESSORIA JURIDICA" },
            { sigla: "ASCOM", unidade: "ASSESSORIA DE COMUNICACAO" },
        ],
        CODUSP: [
            { sigla: "CODUSP", unidade: "COORDENADORIA DE DEFESA DO USUARIO DO SERVICO PUBLICO MUNICIPAL" },
            { sigla: "DPCS", unidade: "DIVISAO DE FOMENTO A PARTICIPACAO E CONTROLE SOCIAL" },
        ],
        AUDI: [
            { sigla: "AUDI", unidade: "AUDITORIA GERAL DO MUNICIPIO" },
            { sigla: "DCMR", unidade: "DIVISAO DE AUDITORIA CONTABIL E MONITORAMENTO DE RECOMENDACOES" },
            { sigla: "DDG", unidade: "DIVISAO DE AUDITORIA DE DESENVOLVIMENTO DE GESTAO" },
            { sigla: "DHM", unidade: "DIVISAO DE AUDITORIA DE DESENVOLVIMENTO HUMANO" },
            { sigla: "DDS", unidade: "DIVISAO DE AUDITORIA DE DESENVOLVIMENTO SOCIAL" },
            { sigla: "DDU", unidade: "DIVISAO DE AUDITORIA DE DESENVOLVIMENTO URBANO" },
            { sigla: "DEA", unidade: "DIVISAO ESPECIAL DE APURACAO" },
        ],
        COPI: [
            { sigla: "COPI", unidade: "COORDENADORIA DE PROMOCAO DA INTEGRIDADE E BOAS PRATICAS" },
            { sigla: "CFCI", unidade: "CENTRO DE FORMACAO EM CONTROLE INTERNO" },
            { sigla: "DPIBP", unidade: "DIVISAO DE PROGRAMA DE INTEGRIDADE E BOAS PRATICAS" },
            { sigla: "DPE", unidade: "DIVISAO DE PROMOCAO DE ETICA E PREVENCAO A CONFLITO DE INTERESSES" },
            { sigla: "DTA", unidade: "DIVISAO DE TRANSPARENCIA ATIVA E DADOS ABERTOS" },
        ],
        CORR: [
            { sigla: "CORR", unidade: "CORREGEDORIA GERAL DO MUNICIPIO" },
            { sigla: "DAJ", unidade: "DIVISAO DE ASSUNTOS JURIDICOS E MONITORAMENTO DE ACORDOS DE LENIENCIA" },
            { sigla: "DPCS", unidade: "DIVISAO DE PROCEDIMENTO COMUM" },
            { sigla: "DPP", unidade: "DIVISAO DE PROCEDIMENTO PATRIMONIAL" },
            { sigla: "DPAR", unidade: "DIVISAO DE PROCESSO ADMINISTRATIVO DE RESPONSABILIZACAO DE PESSOA JURIDICA" },
        ],
        OGM: [
            { sigla: "OGM", unidade: "OUVIDORIA GERAL DO MUNICIPIO" },
            { sigla: "DAPIS", unidade: "DIVISAO DE ATENDIMENTO AO PUBLICO E INTERLOCUCAO SOCIAL" },
            { sigla: "DEPRO", unidade: "DIVISAO DE PROCESSAMENTO DAS DEMANDAS" },
            { sigla: "DREST", unidade: "DIVISAO DE RELATORIOS E ESTATISTICA" },
            { sigla: "DTP", unidade: "DIVISAO DE TRANSPARENCIA PASSIVA" },
        ],
        CAF: [
            { sigla: "CAF", unidade: "COORDENADORIA DE ADMINISTRACAO E FINANCAS" },
            { sigla: "DADM", unidade: "DIVISAO DE ADMINISTRACAO" },
            { sigla: "DEOF", unidade: "DIVISAO DE EXECUCAO ORCAMENTARIA E FINANCEIRA" },
            { sigla: "DIGESP", unidade: "DIVISAO DE GESTAO DE PESSOAS" },
            { sigla: "DLIC", unidade: "DIVISAO DE LICITACOES E CONTRATOS" },
            { sigla: "DTIC", unidade: "DIVISAO DE TECNOLOGIA DA INFORMACAO E COMUNICACAO" },
        ],
        CPD: [
            { sigla: "CPD", unidade: "COORDENADORIA DE PROTECAO DE DADOS PESSOAIS" },
            { sigla: "DCPD", unidade: "DIVISAO DE CONFORMIDADE EM PROTECAO DE DADOS PESSOAIS" },
            { sigla: "DNPD", unidade: "DIVISAO DE NORMATIZACAO EM PROTECAO DE DADOS PESSOAIS" },
        ]
    };

    // Função para atualizar o estado do formulário ao digitar
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    // Função para validar se todos os campos obrigatórios estão preenchidos
    const validarCamposObrigatorios = () => {
        const camposObrigatorios = [
            ...(nomeOpcional ? [] : ["nome"]),
            ...(cargoOpcional ? [] : ["cargo"]),
            "sigla",
            "email",
            "telefone",
            "endereco",
            "cepCidadeEstado"
        ];
        for (const campo of camposObrigatorios) {
            if (!form[campo] || form[campo].trim() === "") {
                return false;
            }
        }
        return true;
    };

    // Função para gerar a imagem da assinatura usando html2canvas
    const gerarImagem = () => {
        if (!validarCamposObrigatorios()) {
            alert("Por favor, preencha todos os campos obrigatórios antes de gerar a assinatura.");
            return;
        }
        html2canvas(cardRef.current, {
            scale: 2 // alta resolução
        }).then((canvas) => {
            const link = document.createElement("a");
            link.download = "assinatura.jpeg";
            link.href = canvas.toDataURL("image/jpeg", 1.0); // qualidade máxima
            link.click();
        });
    };

    // Renderização do componente
    return (
        <div className="container">
            {/* Título da página */}
            <h1 className="text-center mb-4" style={{ color: "#EC6608", marginTop: "00px", fontWeight: "bold", animation: "fadeIn 1s ease-in-out" }}>Gerador de Assinatura de E-mail</h1>
            {/* Formulário de preenchimento dos dados */}
            <form className="container mt-4">
                {/* Campos de nome e cargo, exibidos apenas se não for assinatura departamental */}
                {!cargoOpcional && (
                    <div className="mb-3">
                        <label className="form-label">
                        Nome <span className="text-danger">*</span>
                        </label>
                        <input
                        type="text"
                        name="nome"
                        className="form-control"
                        placeholder="Nome"
                        value={form.nome}
                        onChange={handleChange}
                        />
                    </div>
                )}
                {!cargoOpcional && (
                    <div className="mb-3">
                        <label className="form-label">
                            Cargo <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            name="cargo"
                            className="form-control"
                            placeholder="Cargo"
                            value={form.cargo.replace(/\s*\/\s*$/, '')} // exibe sem a barra
                            onChange={handleChange}
                            onBlur={(e) => {
                                const rawValue = e.target.value.trim();
                                const formatted = rawValue ? `${rawValue} /` : '';
                                setForm({ ...form, cargo: formatted });
                            }}
                        />
                    </div>
                )}
                {/* Switch para alternar entre assinatura individual e departamental */}
                <div className="form-check form-switch mb-1">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="cargoSwitch"
                        checked={cargoOpcional}
                        onChange={() => {
                            const novoValor = !cargoOpcional;
                            setCargoOpcional(novoValor);
                            setNomeOpcional(novoValor); // sincronia entre os campos
                        }}
                    />
                    <label className="form-check-label" htmlFor="cargoSwitch">
                        Assinatura Departamental
                    </label>
                </div>
                {/* Seleção de coordenadoria e setor */}
                <div className="mb-3">
                    <label className="form-label">
                        Setor <span className="text-danger">*</span>
                    </label>
                    <select
                        name="coordenadoria"
                        className="form-select"
                        value={form.coordenadoria}
                        onChange={(e) => {
                            const coord = e.target.value;
                            setForm({ ...form, coordenadoria: coord, sigla: "", unidade: "" });
                        }}
                    >
                        <option value="">Selecione a Coordenadoria</option>
                        {Object.keys(setoresPorCoordenadoria).map((coord) => (
                            <option key={coord} value={coord}>
                                {coord}
                            </option>
                        ))}
                    </select>
                </div>
                {/* Seleção de sigla/unidade, dependente da coordenadoria escolhida */}
                {form.coordenadoria && (
                    <div className="mb-3">
                        <label className="form-label">
                            Sigla/Unidade <span className="text-danger">*</span>
                        </label>
                        <select
                            name="sigla"
                            className="form-select"
                            value={form.sigla}
                            onChange={(e) => {
                                const siglaSelecionada = e.target.value;
                                const unidadeSelecionada =
                                    setoresPorCoordenadoria[form.coordenadoria].find(
                                        (s) => s.sigla === siglaSelecionada
                                    )?.unidade || "";
                                setForm({
                                    ...form,
                                    sigla: siglaSelecionada,
                                    unidade: unidadeSelecionada,
                                });
                            }}
                        >
                            <option value="">Selecione a Sigla/Unidade</option>
                            {setoresPorCoordenadoria[form.coordenadoria].map((item, index) => (
                                <option key={index} value={item.sigla}>
                                    {item.sigla} - {item.unidade}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
                {/* Campo de e-mail */}
                <div className="mb-3">
                    <label className="form-label">
                        Email <span className="text-danger">*</span>
                    </label>
                    <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        value={form.email}
                        onChange={handleChange}
                    />
                </div>
                {/* Campo de telefone com máscara dinâmica */}
                <div className="mb-3">
                    <label className="form-label">
                        Telefone <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        name="telefone"
                        className="form-control"
                        placeholder="Telefone"
                        value={form.telefone}
                        onChange={(e) => {
                            const raw = e.target.value.replace(/\D/g, "");
                            let formatted = raw;
                            if (raw.length <= 10) {
                                formatted = raw.replace(
                                    /(\d{0,2})(\d{0,4})(\d{0,4})/,
                                    (_, ddd, parte1, parte2) =>
                                        `(${ddd}${parte1 ? `) ${parte1}` : ""}${parte2 ? `-${parte2}` : ""}`
                                );
                            } else {
                                formatted = raw.replace(
                                    /(\d{0,2})(\d{0,5})(\d{0,4})/,
                                    (_, ddd, parte1, parte2) =>
                                        `(${ddd}${parte1 ? `) ${parte1}` : ""}${parte2 ? `-${parte2}` : ""}`
                                );
                            }
                            setForm({ ...form, telefone: formatted });
                        }}
                    />
                </div>
                {/* Campo de telefone alternativo com máscara dinâmica */}
                <div className="mb-3">
                    <label className="form-label">Telefone Alternativo</label>
                    <input
                        type="text"
                        name="telefoneAlternativo"
                        className="form-control"
                        placeholder="Telefone alternativo"
                        value={form.telefoneAlternativo}
                        onChange={(e) => {
                            const raw = e.target.value.replace(/\D/g, "");
                            let formatted = raw;
                            if (raw.length <= 10) {
                                formatted = raw.replace(
                                    /(\d{0,2})(\d{0,4})(\d{0,4})/,
                                    (_, ddd, parte1, parte2) =>
                                        `(${ddd}${parte1 ? `) ${parte1}` : ""}${parte2 ? `-${parte2}` : ""}`
                                );
                            } else {
                                formatted = raw.replace(
                                    /(\d{0,2})(\d{0,5})(\d{0,4})/,
                                    (_, ddd, parte1, parte2) =>
                                        `(${ddd}${parte1 ? `) ${parte1}` : ""}${parte2 ? `-${parte2}` : ""}`
                                );
                            }
                            setForm({ ...form, telefoneAlternativo: formatted });
                        }}
                    />
                </div>
                {/* Seleção do local de trabalho, preenche endereço e CEP automaticamente */}
                <div className="mb-3">
                    <label className="form-label">
                        Local de Trabalho <span className="text-danger">*</span>
                    </label>
                    <select
                        className="form-select"
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value === "matarazzo") {
                                setForm({
                                    ...form,
                                    endereco: "Viaduto do Chá, 15 - Centro",
                                    cepCidadeEstado: "01002-020 | São Paulo | SP",
                                });
                            } else if (value === "prates") {
                                setForm({
                                    ...form,
                                    endereco: "Rua Líbero Badaró, 293 - Centro",
                                    cepCidadeEstado: "01009-000 | São Paulo | SP",
                                });
                            } else {
                                setForm({ ...form, endereco: "", cepCidadeEstado: "" });
                            }
                        }}
                    >
                        <option value="">Selecione o prédio</option>
                        <option value="matarazzo">Ed. Matarazzo</option>
                        <option value="prates">Ed. Conde de Prates</option>
                    </select>
                </div>
                {/* Botões de ação: gerar imagem, voltar e ver manual */}
                <div className="d-flex gap-2 mb-3">
                    <button type="button" className="btn btn-primary" onClick={gerarImagem}>
                        Gerar Imagem
                    </button>
                    <Link to="/" className="btn btn-danger d-flex align-items-center">
                        {/* Ícone de voltar */}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-arrow-return-left"
                            viewBox="0 0 16 16"
                        >
                            <path
                                fillRule="evenodd"
                                d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"
                            />
                        </svg>
                        <span className="ms-2">Voltar à tela inicial</span>
                    </Link>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-toggle="modal"
                        data-bs-target="#manualModal"
                    >
                        Ver Manual
                    </button>
                </div>
                {/* Aviso de campos obrigatórios */}
                <p className="text-muted">
                    <span className="text-danger">*</span> Campos de preenchimento obrigatório
                </p>
            </form>
            {/* Renderização da assinatura departamental */}
            {cargoOpcional && (
                <div className="assinatura-preview" ref={cardRef}>
                    <div className="logo-area">
                        <img src={Images.CGM} alt="Logo" />
                        <div className="vertical-line"></div>
                    </div>
                    <div className="info-area">
                        <div className="nome">{form.unidade.toUpperCase()}</div>
                        {/* Exibe função/setor conforme unidade selecionada */}
                        {form.unidade.toUpperCase() == "CONTROLADORIA GERAL DO MUNICIPIO" && (
                            <div className={`funcao ${
                                form.coordenadoria !== form.sigla &&
                                setoresPorCoordenadoria[form.coordenadoria]?.some(item => item.sigla === form.sigla)
                                    ? ""
                                    : ""
                            }`}>
                                {/* Espaço reservado para função caso necessário */}
                            </div>
                        )}
                        {form.unidade.toUpperCase() !== "CONTROLADORIA GERAL DO MUNICIPIO" && (
                            <div className={`funcao ${
                                form.coordenadoria !== form.sigla &&
                                setoresPorCoordenadoria[form.coordenadoria]?.some(item => item.sigla === form.sigla)
                                    ? ""
                                    : ""
                            }`}>
                                {form.coordenadoria === form.sigla
                                    ? "CONTROLADORIA GERAL DO MUNICIPIO/CGM"
                                    : `${
                                        setoresPorCoordenadoria[form.coordenadoria]?.find(
                                            item => item.sigla === form.coordenadoria
                                        )?.unidade || ""
                                    }/CGM`}
                            </div>
                        )}
                        <div className="restante">{form.email}</div>
                        <div className="restante">
                            {form.telefone}
                            {form.telefoneAlternativo && ` | ${form.telefoneAlternativo}`}
                        </div>
                        <div className="restante">{form.endereco}</div>
                        <div className="restante">{form.cepCidadeEstado}</div>
                        <div className="restante">www.prefeitura.sp.gov.br</div>
                    </div>
                </div>
            )}
            {/* Renderização da assinatura individual */}
            {!cargoOpcional && (
                <div className="assinatura-preview" ref={cardRef}>
                    <div className="logo-area">
                        <img src={Images.CGM} alt="Logo" />
                        <div className="vertical-line" ></div>
                    </div>
                    <div className="info-area">
                        <div className="nome">{form.nome.toUpperCase()}</div>
                        <div className="funcao">
                            {form.cargo.toUpperCase()} {form.unidade && form.coordenadoria
                                ? `${form.unidade}/${form.coordenadoria}`
                                : ""}
                        </div>
                        <div className="restante">{form.email}</div>
                        <div className="restante">
                            {form.telefone}
                            {form.telefoneAlternativo && ` | ${form.telefoneAlternativo}`}
                        </div>
                        <div className="restante">{form.endereco}</div>
                        <div className="restante">{form.cepCidadeEstado}</div>
                        <div className="restante">www.prefeitura.sp.gov.br</div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AssinaturaCard;